<template>
    <button
        :disabled="loading || disabled"
        :type="type"
        class="app--button"
        :data-label="label"
        :class="{ 'app--with-tooltip': tooltip != '' }"
    >
        <span :class="loading ? 'invisible' : 'visible'">
            <app--icon v-if="icon" :value="icon" :key="icon" type="far" class="fa-fw" />
            <span :class="tooltip == '' ? '' : 'app--tooltip tooltip-small shadow rounded ' + tooltip">{{
                label
            }}</span>
        </span>
        <app--loader :show="loading"></app--loader>
    </button>
</template>

<script>
export default {
    props: {
        disabled: { type: Boolean, default: false },
        label: { type: String, required: true },
        icon: { type: String, default: '' },
        loading: { type: Boolean, default: false },
        type: { type: String, default: 'button' },
        tooltip: { type: String, default: '' }
    }
}
</script>
